import AssetsManager from '../../common/data/AssetsManager'
import NameSpace from '../../common/ns/NameSpace'

class StageView extends PIXI.Container
{
  // ---------------------------------------------------------------------------------------------------------
	// --	StageView
	// ---------------------------------------------------------------------------------------------------------

  constructor(index, model){
    super();

    //インデックス
    this.index = index

    //モデル保持
    this.model = model

    //コマのムービークリップ配置
    this.stage = AssetsManager.createMovieClipFromAnimation('map', 'map_stage')
    this.stage.anchor.set(0.5, 0.5);
    this.addChild(this.stage);

    //ヒットエリア配置
    this.hitArea = new PIXI.Circle(0, 0, this.stage.width/2)

    //初期位置
    this.x = this.model.pos.x;
    this.y = this.model.pos.y;

    //ボタンにする
    this.buttonMode = true
    this.interactive = true
  }

  /**
   * コマの表示をアップデート
   */
  update(status)
  {
    //表示更新
    this.stage.gotoAndStop(status)
  }

	// ---------------------------------------------------------------------------------------------------------
}

export default StageView